// extracted by mini-css-extract-plugin
export default {"categoryWrapper":"styles_categoryWrapper__FKDb7","caretStyle":"styles_caretStyle__rh-9y","mobile":"styles_mobile__UUO94","active":"styles_active__HJBHy"};